import { render, staticRenderFns } from "./addPromotionTask.vue?vue&type=template&id=73cb21fa&scoped=true&"
import script from "./addPromotionTask.vue?vue&type=script&lang=js&"
export * from "./addPromotionTask.vue?vue&type=script&lang=js&"
import style0 from "./addPromotionTask.vue?vue&type=style&index=0&id=73cb21fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cb21fa",
  null
  
)

export default component.exports